const asc = arr => arr.sort( ( a, b ) => a - b )

const sum = arr => arr.reduce( ( a, b ) => a + b, 0 )

const mean = arr => sum( arr ) / arr.length

// sample standard deviation
export const std = ( arr ) => {
  const mu = mean( arr )
  const diffArr = arr.map( a => ( a - mu ) ** 2 )
  return Math.sqrt( sum( diffArr ) / ( arr.length - 1 ) )
}

const quantile = ( arr, q ) => {
  const sorted = asc( arr )
  const pos = ( sorted.length - 1 ) * q
  const base = Math.floor( pos )
  const rest = pos - base
  if ( sorted[base + 1] !== undefined ) {
    return sorted[base] + rest * ( sorted[base + 1] - sorted[base] )
  } 
  return sorted[base]
    
}

export const q25 = arr => quantile( arr, 0.25 )

export const q50 = arr => quantile( arr, 0.50 )

export const q75 = arr => quantile( arr, 0.75 )

export const median = arr => q50( arr )
